module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_fails.js
// module id = AoXp
// module chunks = 15